export enum LevelType {
  DEAL = 'DEAL',
  LINE = 'LINE',
}
